// extracted by mini-css-extract-plugin
module.exports = {"helpText":"ForgotPasswordModal_helpText__2AsTM"};